import * as actionTypes from '../../actions/actionTypes';

const facebookActionTypes = actionTypes.facebookActionTypes;

/**
 * Facebook login status reducer: update facebook login status
 * @param {object} state - current state
 * @param {object} action
 * @return {object} next state
 */
export function FACEBOOK_loginStatus(state = null, action) {
	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_LOGIN_STATUS:
			return {...action.facebookLoginStatus};
		default:
			return state;
	}
}

/**
 * First name reducer: update facebook data first name
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function FACEBOOK_firstName(state = null, action) {
	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_FIRST_NAME:
			return action.firstName;
		default:
			return state;
	}
}

/**
 * Last name reducer: update facebook data last name
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function FACEBOOK_lastName(state = null, action) {
	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_LAST_NAME:
			return action.lastName;
		default:
			return state;
	}
}

/**
 * Email reducer: update facebook data email
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function FACEBOOK_email(state = null, action) {
	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_EMAIL:
			return action.email;
		default:
			return state;
	}
}

/**
 * Access Token reducer: update facebook data access Token
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function FACEBOOK_accessToken(state = null, action) {
	switch (action.type) {
		case facebookActionTypes.UPDATE_FACEBOOK_ACCESS_TOKEN:
			return action.accessToken;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/reducers/reducers/facebookReducers.js